module.exports = __webpack_public_path__ + "1ff0faf9dd4f107c35190bc656b66629.png";